import React, { useEffect, useState } from 'react'

const PWAUpdateNotification: React.FC = () => {
  const [showUpdatePrompt, setShowUpdatePrompt] = useState(false)
  const [waitingWorker, setWaitingWorker] = useState<ServiceWorker | null>(null)

  useEffect(() => {
    // Check for service worker updates
    if ('serviceWorker' in navigator) {
      navigator.serviceWorker.getRegistration().then((registration) => {
        if (registration) {
          registration.addEventListener('updatefound', () => {
            const newWorker = registration.installing
            if (newWorker) {
              newWorker.addEventListener('statechange', () => {
                if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
                  setWaitingWorker(newWorker)
                  setShowUpdatePrompt(true)
                }
              })
            }
          })
        }
      })
    }
  }, [])

  const updateApp = () => {
    if (waitingWorker) {
      waitingWorker.postMessage({ type: 'SKIP_WAITING' })
      setShowUpdatePrompt(false)
      window.location.reload()
    }
  }

  if (!showUpdatePrompt) {
    return null
  }

  return (
    <div className="fixed bottom-4 right-4 bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-lg shadow-lg p-4 max-w-sm z-50">
      <div className="flex items-center space-x-3">
        <div className="flex-1">
          <h3 className="text-sm font-medium text-gray-900 dark:text-white">
            Nueva versión disponible
          </h3>
          <p className="text-xs text-gray-600 dark:text-gray-300 mt-1">
            Actualiza para obtener las últimas funciones
          </p>
        </div>
        <div className="flex space-x-2">
          <button
            onClick={() => setShowUpdatePrompt(false)}
            className="text-xs text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-200"
          >
            Después
          </button>
          <button
            onClick={updateApp}
            className="text-xs bg-primary text-white px-3 py-1 rounded hover:bg-primary/90"
          >
            Actualizar
          </button>
        </div>
      </div>
    </div>
  )
}

export default PWAUpdateNotification 